import React from 'react';

import { ArticleBlockContentGridCol } from './ArticleBlockContentGridCol';
import StepByStepList from '../../../../StepByStepList/StepByStepList';
import type { StepByStepListProps } from '../../../../StepByStepList/StepByStepList.types';
import { BlockContentContext } from '../../../BlockContent.utils';

interface StepByStepListSerializerProps {
  value: StepByStepListProps;
}

export const StepByStepListBlock = ({ value }: StepByStepListSerializerProps) => (
  <StepByStepList title={value.title} ingress={value.ingress} list={value.list} variant={value.variant} />
);

export const StepByStepListSerializer = (context: BlockContentContext = BlockContentContext.Stripped) => {
  if (context === BlockContentContext.Article) {
    return ({ value }: StepByStepListSerializerProps) => (
      <ArticleBlockContentGridCol className="blockStepByStepList">
        <StepByStepListBlock value={value} />
      </ArticleBlockContentGridCol>
    );
  }
  return ({ value }: StepByStepListSerializerProps) => <StepByStepListBlock value={value} />;
};
